import { TweenMax } from "gsap";
import App from '../../../vendor_core/core/src/App';
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { OverlayType } from '../../../vendor_core/core/src/server/data/ISpinData';
import { State } from "../../../vendor_core/core/src/states/State";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import Reel from '../../../vendor_core/core/src/views/Reel';
import BBModel from "../model/BBModel";
import BBAnimationsHelper from "../utils/BBAnimationsHelper";
import BBUtils from '../utils/utils';
import BBReelGroup from "../view/BBReelGroup";

export default class BBCascadeOnSymPoppedState extends State {
    private anticipationDelayTime = 1;
    public enter(): void {
        super.enter();
        let reelScene = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene()
        let reelGroup = reelScene.getSubView("ReelGroup") as BBReelGroup;
        reelGroup.cascade();

        // if (SpinModel.cascadeIndex == SpinModel.cascades?.length - 1 && SpinModel.getCurrentSpinProperty("cascadeExplodesOffsets")?.length === 0) {
        //     // debugger
        //     const logoAnim = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene().spineAnimations.get("logo");
        //     logoAnim.play("beat", false, 2);
        //     logoAnim.setOnCompleteAnim(() => {
        //         debugger
        //         logoAnim.play();
        //     })
        // }
        // BBAnimationsHelper.playAnticipationAnim(reelGroup);

        if (BBModel.cascades && BBModel.cascades[SpinModel.cascadeIndex]
            && BBModel.cascades[SpinModel.cascadeIndex].transform &&
            BBModel.cascades[SpinModel.cascadeIndex].transform.length == 2) {
            const logoAnim = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene().spineAnimations.get("logo");
            BBModel.hasAnticipation = true;
            BBAnimationsHelper.playAnticipationAnim(reelGroup);
            logoAnim.playAsync("beat").then(() => {
                logoAnim.play();
            });

            TweenMax.delayedCall(this.anticipationDelayTime, () => {
                this.triggerNextCascade();
                this.exit();
            })

            // TweenMax.delayedCall(this.anticipationTime, () => {
            //     let sym = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene().anims.get("logo1")
            //     TweenMax.to(sym, 0.15, {
            //         width: sym.width + sym.width / 5,
            //         height: sym.height + sym.height / 5,
            //         x: sym.x - sym.width / 10,
            //         y: sym.y - sym.height / 10,
            //         yoyo: true,
            //         repeat: 3,
            //         onComplete: () => {
            //             this.triggerNextCascade();
            //             this.exit();
            //         }
            //     })
            // })
        } else {
            // reelGroup.reels.forEach(reel => {
            //     const explodedItems = explodesMap.length > 0 ? explodesMap[reel.reelIndex] : [];
            //     console.log(explodedItems);

            // })
            this.triggerNextCascade();
            this.exit();
        }

    }
    protected triggerNextCascade() {
        SpinModel.cascadeIndex++;
    }
}
